export default __webpack_public_path__ + "static/media/berxi.8ad86327.png";